const SCORE_WEIGHTS = { name: 10, email: 10, phone: 5, summary: 15, work: 25, edu: 15, skills: 10, projects: 5, certs: 5 };

export function calcCompleteness({ personalInfo, professionalSummary, workExperience, education, skills, projects, certifications }) {
  let score = 0;
  if (personalInfo.name) score += SCORE_WEIGHTS.name;
  if (personalInfo.email) score += SCORE_WEIGHTS.email;
  if (personalInfo.phone) score += SCORE_WEIGHTS.phone;
  if (professionalSummary) score += SCORE_WEIGHTS.summary;
  if (workExperience.length > 0) score += SCORE_WEIGHTS.work;
  if (education.length > 0) score += SCORE_WEIGHTS.edu;
  if (Object.values(skills).some(arr => arr.length > 0)) score += SCORE_WEIGHTS.skills;
  if (projects.length > 0) score += SCORE_WEIGHTS.projects;
  if (certifications.length > 0) score += SCORE_WEIGHTS.certs;
  return score;
}
